export default "__VITE_ASSET__DSHY46z8__"